import * as analyticHelper from '@/lib/analytic-helper';
import Vue from 'vue';
import AxNavbar from './AxNavbar.vue';

export interface IPermission {
    hidden: boolean;
}

interface IGroupHeader {
    caption: string;
    type: 'GroupHeader';
    permission?: IPermission;
}

interface IColumnBreak {
    type: 'ColumnBreak';
}

type RouteTarget = 'modal' | 'window' | 'default' | undefined;

export interface IMenuLink {
    type?: undefined | 'default';
    caption: string;
    routeUrl: string;
    routeTarget: RouteTarget;
    menuItems?: IMenuItem[];
    events?: IEvent;
    modal?: boolean;
}

export type IMenuItemsWrapper = {
    menuItems: IMenuItem[];
}

export type IMenuItem = IMenuLink | IGroupHeader | IColumnBreak;
export interface IMenuBar {
    caption?: string;
    code: string;
    menus?: IMenu[];
}

export interface IMenu {
    caption: string;
    menuItems: IMenuItem[];
}
export interface IEvent {
    caption: string,
    items: IMenuLink[],
    permission?: IPermission,
    type?: string
}

export interface IGroupedItems {
    caption: string;
    items: IMenuLink[];
}

export default Vue.extend({
    name: 'ax-navbar',
    components: {
        AxNavbar,
    },
    props: {
        username: {
            type: String,
            required: true,
        },
        options: {
            type: Object,
            default: () => ({
                baseUrl: 'https://app.class.com.au/',
                navData: {
                    pageTitle: 'Home',
                    code: 'Home',
                },
                eventsData: null,
            }),
        },
    },
    render(createElement) {
        return createElement(AxNavbar, {
            props: {
                username: this.username,
                menuBar: this.options?.navData,
                eventsMenuBar: this.options?.eventsData,
                baseUrl: this.options?.baseUrl,
                homeUrl: this.options?.homeUrl,
                clientViewPath: this.options?.clientViewPath,
                classAgent: this.options?.classAgent
            },
            on: {
                newFeatureToggled: (payload: any) => {
                  this.$emit('newFeatureToggled', payload);
                  analyticHelper.powerbarSwitchEvent({ newValue: true });
                },
                navigate: (payload: any) => {
                  this.$emit('navigate', payload);
                  analyticHelper.powerbarSearchItemActivatedEvent(payload);
                },
            },
        });
    },
});
